import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { services } from '../data/services';
import './Services.css';

const Services = () => {
  const navigate = useNavigate();

  // Handle hash navigation from footer links (redirect to new URLs)
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      const service = services.find(s => s.id === hash);
      if (service) {
        navigate(`/services/${service.slug}`, { replace: true });
      }
    }
  }, [navigate]);

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <h1 className="page-title">Our Services</h1>
          <p className="page-subtitle">
            Everything outside - from site clearing to final landscaping. 
            Over 30 years of experience serving the Greater Boston Area.
          </p>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="services-grid-section">
        <div className="container">
          <div className="services-grid">
            {/* First row: 3 cards */}
            {services.slice(0, 3).map((service, index) => (
              <Link
                key={index}
                to={`/services/${service.slug}`}
                className="service-card"
              >
                <div 
                  className="service-card-image"
                  style={{
                    backgroundImage: `url(${service.image})`
                  }}
                ></div>
                <div className="service-card-content">
                  <img src={service.icon} alt={service.title} className="service-card-icon" />
                  <h3 className="service-card-title">{service.title}</h3>
                  <p className="service-card-description">{service.description}</p>
                  <span className="service-card-link">Learn More →</span>
                </div>
              </Link>
            ))}
            
            {/* Second row: 2 cards with "The TB Way" card in middle */}
            {services.slice(3, 4).map((service, index) => (
              <Link
                key={index + 3}
                to={`/services/${service.slug}`}
                className="service-card"
              >
                <div 
                  className="service-card-image"
                  style={{
                    backgroundImage: `url(${service.image})`
                  }}
                ></div>
                <div className="service-card-content">
                  <img src={service.icon} alt={service.title} className="service-card-icon" />
                  <h3 className="service-card-title">{service.title}</h3>
                  <p className="service-card-description">{service.description}</p>
                  <span className="service-card-link">Learn More →</span>
                </div>
              </Link>
            ))}
            <div className="service-card-tb-way">
              <h2 className="tb-way-title">The TB Way</h2>
            </div>
            {services.slice(4, 5).map((service, index) => (
              <Link
                key={index + 4}
                to={`/services/${service.slug}`}
                className="service-card"
              >
                <div 
                  className="service-card-image"
                  style={{
                    backgroundImage: `url(${service.image})`
                  }}
                ></div>
                <div className="service-card-content">
                  <img src={service.icon} alt={service.title} className="service-card-icon" />
                  <h3 className="service-card-title">{service.title}</h3>
                  <p className="service-card-description">{service.description}</p>
                  <span className="service-card-link">Learn More →</span>
                </div>
              </Link>
            ))}
            
            {/* Third row: 3 cards */}
            {services.slice(5, 8).map((service, index) => (
              <Link
                key={index + 5}
                to={`/services/${service.slug}`}
                className="service-card"
              >
                <div 
                  className="service-card-image"
                  style={{
                    backgroundImage: `url(${service.image})`
                  }}
                ></div>
                <div className="service-card-content">
                  <img src={service.icon} alt={service.title} className="service-card-icon" />
                  <h3 className="service-card-title">{service.title}</h3>
                  <p className="service-card-description">{service.description}</p>
                  <span className="service-card-link">Learn More →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="services-process">
        <div className="container">
          <h2 className="section-title">Complete Site Development</h2>
          <p className="section-description">
            TB Construction provides comprehensive site development services for both residential and commercial projects. 
            We handle everything outside, ensuring your site is properly prepared, developed, and finished to the highest standards.
          </p>
          <div className="process-highlights">
            <div className="highlight">
              <img src="/icons/TB_Icons_Consturction Worker.png" alt="Residential Projects" className="highlight-icon" />
              <h3>Residential Projects</h3>
              <p>From single-family homes to multi-unit developments</p>
            </div>
            <div className="highlight">
              <img src="/icons/TB_Icons_Hardhat.png" alt="Commercial Projects" className="highlight-icon" />
              <h3>Commercial Projects</h3>
              <p>Large-scale commercial developments and infrastructure</p>
            </div>
            <div className="highlight">
              <img src="/icons/TB_Icons_Measuring Tape.png" alt="Approved Plans Ready" className="highlight-icon" />
              <h3>Approved Plans Ready</h3>
              <p>We work with your approved architectural construction documents</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <div className="container">
          <h2>Ready to Start Your Project?</h2>
          <p>Contact us today to discuss your site development needs and get a detailed proposal</p>
          <Link to="/contact" className="btn-primary btn-large">
            Get Your Proposal
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;

